import React from 'react';

import ResiduesFilterForm, {ResiduesFilterFormProps} from './ResiduesFilterForm';

export default function PrositeFilterForm(props: ResiduesFilterFormProps): JSX.Element {
  return <ResiduesFilterForm {...props} placeholder="PROSITE Pattern" />;
}
